import { RetryActionTypes, RetryActions, RetryState } from './types';

const initialState: RetryState = {
  retryData: undefined,
  initiatePaymentData: undefined,
  processAuthorisationData: undefined,
  customerId: undefined,
};

export const retryReducer = (state = initialState, action: RetryActionTypes): RetryState => {
  switch (action.type) {
    case RetryActions.retry_fetch_success: {
      const retryData = action.payload;
      return { ...state, retryData };
    }
    case RetryActions.initiate_payment_start:
      return {
        ...state,
        initiatePaymentData: {
          ...state.initiatePaymentData,
          isFetching: true,
          isFailure: false,
          retryPaymentStatus: undefined,
          actionObject: undefined,
          paymentId: undefined,
        },
      };
    case RetryActions.initiate_payment_failure:
      return {
        ...state,
        initiatePaymentData: {
          ...state.initiatePaymentData,
          isFetching: false,
          isFailure: true,
        },
      };
    case RetryActions.initiate_payment_success: {
      const paymentActionObject = action.payload.action;
      const paymentId = action.payload.paymentId;
      return {
        ...state,
        initiatePaymentData: {
          ...state.initiatePaymentData,
          isFetching: false,
          isFailure: false,
          actionObject: paymentActionObject,
          paymentId: paymentId,
          retryPaymentStatus: action.payload.retryPaymentStatus,
          authorizationId: action.payload.authorizationId,
        },
      };
    }
    case RetryActions.process_payment_authorisation_start:
      return {
        ...state,
        processAuthorisationData: {
          ...state.processAuthorisationData,
          isFetching: true,
          isFailure: false,
        },
      };
    case RetryActions.process_payment_authorisation_failure:
      return {
        ...state,
        processAuthorisationData: {
          ...state.processAuthorisationData,
          isFetching: false,
          isFailure: true,
        },
      };
    case RetryActions.process_payment_authorisation_success: {
      const retryProcessAuthorisationResponse = action.payload;
      return {
        ...state,
        processAuthorisationData: {
          ...state.processAuthorisationData,
          isFetching: false,
          isFailure: false,
          authorizationResult: retryProcessAuthorisationResponse,
        },
      };
    }
    default:
      return state;
  }
};
